import { Component } from '@angular/core';
import { BaseComponent } from '@uw/core/base.component';
import { AuthService } from '@uw/core/services/auth.service';
import { ChangePasswordFormComponent } from '../change-password-form/change-password-form.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [ChangePasswordFormComponent, TranslateModule]
})
export class ChangePasswordComponent extends BaseComponent {
  buttonLoading = false;

  constructor(private authService: AuthService) {
    super();
  }


  onChangePassword(changePasswordFormData: any): void {

    this.errorMessage = '';
    this.buttonLoading = true;
    this.authService.changePassword(changePasswordFormData).subscribe(
      (data) => {
        if (data) {
          this.buttonLoading = false;
          this.showSuccess('change_password.password_updated_msg');
        }
      },
      (err) => {
        this.buttonLoading = false;
        this.errorMessage =
        err && err.message && err.message == 'cannot_reuse_password'
        ? this.translateService.instant(
            'change_password.error.code.cannot_reuse_password'
          ) :
          (err.message == 'Incorrect password.' ? this.translateService.instant('change_password.error.code.incorrect_password') :
              this.translateService.instant(
                'messages.password_update_failed'
              ))
      }
    );
  }
}
